// extracted by mini-css-extract-plugin
module.exports = {"editButton":"InputEditButton_editButton__P84x1"};